import axios from "axios";
//•Production
axios.defaults.baseURL = 'https://service.gbitex.com/api'
//•Test
// axios.defaults.baseURL = ''

axios.defaults.headers.common['Authorization']='Bearer' +' ' + localStorage.getItem('token');